import Cookies from 'js-cookie';
import HttpClient from '../../HttpClient';
import {baseURL} from '../../url';

class Auth extends HttpClient {

    constructor(Callback) {
        // const url = process.env.API_URL;

        super(Callback, {
            baseURL,
            headers: {},
            Callback,
        });
        this.setHeader('Content-Type', 'application/json')
        this.setHeader('Accept', 'application/json')
        this.setBearerAuth(`Bearer  ${Cookies.get('token')}`,)

    }

    static request(Callback) {
        return new Auth(Callback);
    }


    // logout() {
    //     return this.post('logout')
    // }

    login(data) {
        return this.post('Account/login', data)
    }
    warningCount() {
        return this.get('Warning/count')
    }

    roles(data) {
        return this.get('Account/roles')
    }


    register(data,id) {
        return this[id ? 'put' : 'post'](`Account/${id || 'register'}`,data)
    }



    changeStatus(userName,status) {
        return this.put(`Account/Activation/${userName}?IsEnabled=${status}`)
    }



    UsersFullName(userName,status) {
        return this.get(`Account/UsersFullName`)
    }



    password(data) {
        return this.put(`Account/password`,data)
    }



}

export default Auth;
